import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hello" }
const _hoisted_2 = {
  id: "buttons",
  style: {"position":"absolute","width":"400px","height":"200px","border":"1px solid #888","background":"#040b","left":"100px","top":"20px","font-size":"17px","border-radius":"10px","text-align":"left","padding":"10px"}
}
const _hoisted_3 = {
  id: "engine",
  style: {"position":"absolute","width":"200px","height":"500px","border":"1px solid #888","background":"#040b","left":"20px","top":"300px","font-size":"17px","border-radius":"10px","text-align":"left","padding":"10px"}
}
const _hoisted_4 = ["textContent"]
const _hoisted_5 = ["textContent"]
const _hoisted_6 = ["textContent"]
const _hoisted_7 = ["textContent"]
const _hoisted_8 = ["textContent"]
const _hoisted_9 = ["textContent"]
const _hoisted_10 = ["textContent"]
const _hoisted_11 = {
  id: "info",
  style: {"position":"absolute","width":"200px","height":"500px","border":"1px solid #888","background":"#040b","right":"20px","top":"20px","font-size":"17px","border-radius":"10px","text-align":"left","padding":"10px"}
}
const _hoisted_12 = ["textContent"]
const _hoisted_13 = {
  id: "canvas",
  ref: "webGl",
  class: "webGl",
  style: {"z-index":"-10","position":"absolute","left":"0","top":"0","width":"100%","height":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createTextVNode("Карта: ")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          plain: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.buttonClick('level_infinity_world')))
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [
            _createTextVNode("Планета")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          plain: "",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.buttonClick('level_asteroid')))
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [
            _createTextVNode("Астероид")
          ])),
          _: 1
        }),
        _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
        _cache[13] || (_cache[13] = _createElementVNode("hr", null, null, -1)),
        _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_button, {
          plain: "",
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.buttonClick('change_camera')))
        }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [
            _createTextVNode("Камера")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          plain: "",
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.buttonClick('change_car_show_mode')))
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [
            _createTextVNode("Режим отображения машины, физика/графика")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          plain: "",
          onClick: _cache[4] || (_cache[4] = ($event: any) => ($options.buttonClick('change_terrain_show_mode')))
        }, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [
            _createTextVNode("Показать/убрать физическую поверхность")
          ])),
          _: 1
        }),
        _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_checkbox, {
          onClick: _cache[5] || (_cache[5] = ($event: any) => ($options.buttonClick('change_auto_steering'))),
          id: "autoSteeringCheckbox",
          label: "Авторуль",
          size: "large"
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => [
            _cache[16] || (_cache[16] = _createTextVNode("Сцепление: ")),
            _createElementVNode("span", {
              textContent: _toDisplayString(_ctx.carClutch),
              id: "carClutch"
            }, null, 8, _hoisted_4)
          ]),
          _: 1
        }),
        _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => [
            _cache[17] || (_cache[17] = _createTextVNode("Передача: ")),
            _createElementVNode("span", {
              textContent: _toDisplayString(_ctx.carGear),
              id: "carGear"
            }, null, 8, _hoisted_5)
          ]),
          _: 1
        }),
        _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => [
            _cache[18] || (_cache[18] = _createTextVNode("Скорость: ")),
            _createElementVNode("span", {
              textContent: _toDisplayString(_ctx.carSpeed),
              id: "carSpeed"
            }, null, 8, _hoisted_6)
          ]),
          _: 1
        }),
        _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => [
            _cache[19] || (_cache[19] = _createTextVNode("Обороты: ")),
            _createElementVNode("span", {
              textContent: _toDisplayString(_ctx.carRpm),
              id: "carRpm"
            }, null, 8, _hoisted_7)
          ]),
          _: 1
        }),
        _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
        _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => [
            _cache[20] || (_cache[20] = _createTextVNode("Авторуль: ")),
            _createElementVNode("span", {
              textContent: _toDisplayString(_ctx.carAutoSteering),
              id: "carAutoSteering"
            }, null, 8, _hoisted_8)
          ]),
          _: 1
        }),
        _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
        _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => [
            _cache[21] || (_cache[21] = _createTextVNode("Направление: ")),
            _createElementVNode("span", {
              textContent: _toDisplayString(_ctx.carVector),
              id: "carVector"
            }, null, 8, _hoisted_9)
          ]),
          _: 1
        }),
        _cache[30] || (_cache[30] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => [
            _cache[22] || (_cache[22] = _createTextVNode("Сила: ")),
            _createElementVNode("span", {
              textContent: _toDisplayString(_ctx.carForce),
              id: "carForce"
            }, null, 8, _hoisted_10)
          ]),
          _: 1
        }),
        _cache[31] || (_cache[31] = _createElementVNode("br", null, null, -1))
      ]),
      _createElementVNode("h1", null, _toDisplayString(_ctx.msg), 1),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => [
            _cache[32] || (_cache[32] = _createTextVNode("Руль: ")),
            _createElementVNode("span", {
              textContent: _toDisplayString(_ctx.steering),
              id: "steering"
            }, null, 8, _hoisted_12)
          ]),
          _: 1
        }),
        _cache[45] || (_cache[45] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => _cache[33] || (_cache[33] = [
            _createTextVNode("ПозицияX: "),
            _createElementVNode("span", { id: "positionX" }, null, -1)
          ])),
          _: 1
        }),
        _cache[46] || (_cache[46] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => _cache[34] || (_cache[34] = [
            _createTextVNode("ПозицияY: "),
            _createElementVNode("span", { id: "positionY" }, null, -1)
          ])),
          _: 1
        }),
        _cache[47] || (_cache[47] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => _cache[35] || (_cache[35] = [
            _createTextVNode("ПозицияZ: "),
            _createElementVNode("span", { id: "positionZ" }, null, -1)
          ])),
          _: 1
        }),
        _cache[48] || (_cache[48] = _createElementVNode("br", null, null, -1)),
        _cache[49] || (_cache[49] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => _cache[36] || (_cache[36] = [
            _createTextVNode("cellPhysX: "),
            _createElementVNode("span", { id: "cellPhysX" }, null, -1)
          ])),
          _: 1
        }),
        _cache[50] || (_cache[50] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => _cache[37] || (_cache[37] = [
            _createTextVNode("cellPhysZ: "),
            _createElementVNode("span", { id: "cellPhysZ" }, null, -1)
          ])),
          _: 1
        }),
        _cache[51] || (_cache[51] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => _cache[38] || (_cache[38] = [
            _createTextVNode("physSquares: "),
            _createElementVNode("span", { id: "physSquares" }, null, -1)
          ])),
          _: 1
        }),
        _cache[52] || (_cache[52] = _createElementVNode("br", null, null, -1)),
        _cache[53] || (_cache[53] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => _cache[39] || (_cache[39] = [
            _createTextVNode("numPolygons: "),
            _createElementVNode("span", { id: "numPolygons" }, null, -1)
          ])),
          _: 1
        }),
        _cache[54] || (_cache[54] = _createElementVNode("br", null, null, -1)),
        _cache[55] || (_cache[55] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => _cache[40] || (_cache[40] = [
            _createTextVNode("numPhysSquares: "),
            _createElementVNode("span", { id: "numPhysSquares" }, null, -1)
          ])),
          _: 1
        }),
        _cache[56] || (_cache[56] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => _cache[41] || (_cache[41] = [
            _createTextVNode("numGraphSquares: "),
            _createElementVNode("span", { id: "numGraphSquares" }, null, -1)
          ])),
          _: 1
        }),
        _cache[57] || (_cache[57] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => _cache[42] || (_cache[42] = [
            _createTextVNode("numSceneElements: "),
            _createElementVNode("span", { id: "numSceneElements" }, null, -1)
          ])),
          _: 1
        }),
        _cache[58] || (_cache[58] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => _cache[43] || (_cache[43] = [
            _createTextVNode("numMapElements: "),
            _createElementVNode("span", { id: "numMapElements" }, null, -1)
          ])),
          _: 1
        }),
        _cache[59] || (_cache[59] = _createElementVNode("br", null, null, -1)),
        _cache[60] || (_cache[60] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => _cache[44] || (_cache[44] = [
            _createTextVNode("numPhysWorldElements: "),
            _createElementVNode("span", { id: "numPhysWorldElements" }, null, -1)
          ])),
          _: 1
        }),
        _cache[61] || (_cache[61] = _createElementVNode("br", null, null, -1))
      ])
    ]),
    _createElementVNode("canvas", _hoisted_13, null, 512)
  ], 64))
}